module.exports = __webpack_public_path__ + "img/policy-compliance-status.cfda9a0c.png";